import { logError } from "@/new_actions/errors/log_error";

/**
 * In production, Server Component errors have their message censored by
 * Next.js. The real error is already logged server-side via onRequestError in
 * instrumentation.ts, so error boundaries should skip double-logging those.
 */
export function isCensoredServerError(error: Error): boolean {
  return error.message.includes("omitted in production");
}

/** Log a client-side React error unless it is a censored server error. */
export function logClientError(error: Error, fallbackMessage: string) {
  if (isCensoredServerError(error)) return;
  logError({
    message: error.message || fallbackMessage,
    type: "react_error",
    source: typeof window !== "undefined" ? window.location.pathname : undefined,
    stack: error.stack,
  });
}
